import Swiper from 'swiper/bundle';

function initializePage() {
    console.info('initializePage()');
}

initializePage();
